import { render, staticRenderFns } from "./poperView.vue?vue&type=template&id=d5687cb8&scoped=true"
import script from "./poperView.vue?vue&type=script&lang=js"
export * from "./poperView.vue?vue&type=script&lang=js"
import style0 from "./poperView.vue?vue&type=style&index=0&id=d5687cb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5687cb8",
  null
  
)

export default component.exports